import { TThunkAction } from '../../types/redux';
import { EStatus } from '../../types/likes';
import { setReviewReactionAction } from './actions';
import {
  ISetReviewReactionWebResponse,
  ISetReviewReactionWebResponse200,
  ISetReviewReactionWebResponse400,
  fetchSetReviewReactionWeb,
} from '../../repositories/newbuilding-reviews/v1/set-review-reaction-web';
import { mapLabelFromState, trackReactionAnalyticClick } from './analytics/reactionAnalytic';
import { getReviewById } from '../../selectors/reviews';
import { getObjectRating } from '../../selectors/objectInfo';
import { EType } from '../../repositories/newbuilding-reviews/entities/set_review_reaction_web/SetReviewReactionWebRequestSchema';

interface IParams {
  reviewId: string;
  type: EStatus;
}

export function setReviewReaction({ reviewId, type }: IParams): TThunkAction<Promise<boolean>> {
  return async (dispatch, getState, context) => {
    const { logger, httpApi } = context;

    try {
      const siteType = context.custom.deviceType;
      const state = getState();
      const rating = getObjectRating(state);
      const { like } = getReviewById(reviewId)(state);
      const { response } = await fetchSetReviewReactionWeb<
        ISetReviewReactionWebResponse200,
        ISetReviewReactionWebResponse400
      >({
        httpApi,
        parameters: { reviewId, type: type as unknown as EType },
      });

      const label = mapLabelFromState({
        currentState: like.status,
        nextState: (response as ISetReviewReactionWebResponse).type as unknown as EStatus,
      });
      const page = {
        offerType: 'JK',
        pageType: 'ReviewsJK',
        siteType,
        extra: {
          rating,
          review_id: reviewId,
          type: 'review',
        },
      };
      trackReactionAnalyticClick({ label, page });
      dispatch(
        setReviewReactionAction({
          reviewId,
          type: (response as ISetReviewReactionWebResponse).type as unknown as EStatus,
        }),
      );

      return true;
    } catch (error) {
      logger.error(error, {
        domain: 'answers#setAnswerReaction',
        message: error.message,
      });

      return false;
    }
  };
}
